/* global axios */
import ApiClient from './ApiClient';

class WebPropertiesAPI extends ApiClient {
  constructor() {
    super('web_properties', { accountScoped: true });
  }

  create(payload) {
    return axios.post(this.url, { web_property: payload });
  }

  update(id, payload) {
    return axios.patch(`${this.url}/${id}`, { web_property: payload });
  }

  regenerateSecret(id) {
    return axios.post(`${this.url}/${id}/regenerate_secret`);
  }
}

export default new WebPropertiesAPI();
